import Switch from "components/v2/Switch";
import React from "react";

import style from "./style.module.css";

const CookiesContent = ({ cookies, onToggleChange, cookiePreferences }) => {
  return (
    <div className={style.cookieContentDetails}>
      <p>
        We use cookies to help you navigate efficiently and perform certain functions. You will find detailed
        information about all cookies under each consent category below.
      </p>
      <p>
        The cookies that are categorized as "Necessary" are stored on your browser as they are essential for enabling
        the basic functionalities of the site.
      </p>
      <p>
        We also uses third-party cookies that help us analyze how you use this website, store your preferences, and
        provide the content and advertisements that are relevant to you. These cookies will only be stored in your
        browser with your previous consent.
      </p>
      <p>
        You can choose to enable or disable some or all of these cookies but disabling some of them may affect your
        browsing experience.
      </p>
      <p>
        If at any point in the future you wish to modify your preferences kindly take the necessary action of clearing
        your cookies.
      </p>
      {cookies.map((cookie) => (
        <div className={style.cookieBox} key={cookie.title}>
          <div className={style.divider}></div>
          <div className={style.cookieBoxrow}>
            <h6>{cookie.title}</h6>
            {cookie.checkbox && (
              <Switch
                label={"Advanced"}
                disable={false}
                checked={cookiePreferences[`${cookie.title.toLowerCase()}`]}
                onChange={(e) => onToggleChange(e, cookie.title)}
              />
            )}
          </div>
          <p>{cookie.description}</p>
          {cookie.tag && <span className={style.cookieTag}>{cookie.tag}</span>}
        </div>
      ))}
    </div>
  );
};

export default CookiesContent;
